import SoleraAccountCreationPage from './SoleraAccountCreationPage';

export default SoleraAccountCreationPage;
